import DpitNotices from './modules/DpitNotices';
import DPProOnlyOption from './modules/DPProOnlyOption';
import AdminThemeColors from '../../../includes/assets/js/modules/AdminThemeColors';


jQuery(document).ready(($) => {
	window.$ = $;
	if (window.dp_main_admin_config.dpDebugEn) console.log('Admin config:', window.dp_main_admin_config);
	new DpitNotices(window.dp_main_admin_config);
	new DPProOnlyOption(window.dp_main_admin_config);
	new AdminThemeColors(window.dp_main_admin_config);
	if (document.querySelector('.post-type-dp_intro_tours .wp-list-table')) {
		import(/* webpackChunkName: "AdminTourTable" */ './modules/AdminTourTable').then(adminTourTable => {
			new adminTourTable.default(window.dp_main_admin_config);
		});
	}
});
